import { ApplicationElement, html } from '../application_element/element.js';

import style from './style.lit.css';

/**
 * Simple grid layout
 *
 * @prop rounded - Should round the edges of grid?
 * @prop gap - Gap between grid items (options: xs, sm, md, lg, xl)
 * @prop col - The number of columns the grid will have (max: 5)
 * @prop imperfection - Number of items in last grid row (0 if row is full), it will be set automatically for you. It is needed for css to determine: which borders to curve in rounded grids
 *
 * @slot default - List of grid items
 * @cssprop [--border-radius=8px] Border radius rounded grid children
 */

export default class Grid extends ApplicationElement {
  static styles = [style];

  static properties = {
    rounded: { type: Boolean, reflect: true },
    gap: { type: String, reflect: true },
    col: { type: Number, reflect: true },
    // no of items % no of columns (-1 if columns is bigger then items)
    imperfection: { type: Number, reflect: true },
  };

  handleSlotchange(e) {
    const count = e.target.assignedElements({ flatten: true }).length;
    if (count < this.col) this.imperfection = -1;
    else this.imperfection = count % this.col;
  }

  render() {
    return html` <slot @slotchange=${this.handleSlotchange}></slot> `;
  }
}

Grid.registerTagName('ef-grid');

customElements.get('ef-grid') || customElements.define('ef-grid', Grid);
